import React from "react";
import PropTypes from "prop-types";
import "../../styling/TripleSwitch.css";

const valueType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool
]);

const propTypes = {
  labels: PropTypes.shape({
    left: {
      title: PropTypes.string.isRequired,
      value: valueType
    },
    center: {
      title: PropTypes.string.isRequired,
      value: valueType
    },
    right: {
      title: PropTypes.string.isRequired,
      value: valueType
    },
  }),
  onChange: PropTypes.func.isRequired,
  value: valueType,
  styles: PropTypes.object
};

const defaultProps = {
  labels: {
    left: {
      title: "left",
      value: "left"
    },
    center: {
      title: "center",
      value: "center"
    },
    right: {
      title: "right",
      value: "right"
    },
  },
  value: "left",
  onChange: (value) => console.log("value:", value)
};

class TripleSwitch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      switchPosition: "left",
      animation: null
    };

    this.getSwitchAnimation = this.getSwitchAnimation.bind(this)
    this.inputChange = this.inputChange.bind(this)
  }

  componentDidMount() {
    const { value, labels } = this.props;
    let animation = null;
    let pos = null;
    if (value === labels.left.value) {
      pos = "left"
    }
    if (value === labels.center.value) {
      pos = "center"
      animation = "left-to-center"
    }
    if (value === labels.right.value) {
      pos = "right"
      animation = "left-to-right"
    }
    this.setState({ switchPosition: pos, animation });
    this.getSwitchAnimation(value)
  }

  getSwitchAnimation = (value) => {
    const { switchPosition } = this.state;
    const { labels } = this.props;

    let animation = null;
    let pos = null;

    if (value === labels.center.value && switchPosition === "left") {
      animation = "left-to-center";
      pos = "center";
    } else if (value === labels.right.value && switchPosition === "center") {
      animation = "center-to-right";
      pos = "right";
    } else if (value === labels.center.value && switchPosition === "right") {
      animation = "right-to-center";
      pos = "center";
    } else if (value === labels.left.value && switchPosition === "center") {
      animation = "center-to-left";
      pos = "left";
    } else if (value === labels.right.value && switchPosition === "left") {
      animation = "left-to-right";
      pos = "right";
    } else if (value === labels.left.value && switchPosition === "right") {
      animation = "right-to-left";
      pos = "left";
    }
    this.setState({ switchPosition: pos, animation });
  };

  inputChange = (value) => {
    let change = this.props.onChange(value);
    if (change !== false) this.getSwitchAnimation(value);
  }

  render() {
    const { labels } = this.props;

    return (
      <div className="main-container">
        <div
          className={`switch ${this.state.animation} ${this.state.switchPosition}-position`}
        ></div>
        <input
          onChange={(e) => this.inputChange(e.target.value)}
          name="map-switch"
          id="left"
          type="radio"
          value={labels.left.value}
        />
        <label
          className={`left-label ${
            this.state.switchPosition === "left" && "black-font"
          }`}
          htmlFor="left"
        >
          <h4>{labels.left.title}</h4>
        </label>

        <input
          onChange={(e) => this.inputChange(e.target.value)}
          name="map-switch"
          id="center"
          type="radio"
          value={labels.center.value}
        />
        <label
          className={`center-label ${
            this.state.switchPosition === "center" && "black-font"
          }`}
          htmlFor="center"
        >
          <h4>{labels.center.title}</h4>
        </label>

        <input
          onChange={(e) => this.inputChange(e.target.value)}
          name="map-switch"
          id="right"
          type="radio"
          value={labels.right.value}
        />
        <label
          className={`right-label ${
            this.state.switchPosition === "right" && "black-font"
          }`}
          htmlFor="right"
        >
          <h4>{labels.right.title}</h4>
        </label>
      </div>
    );
  }
}

TripleSwitch.propTypes = propTypes;
TripleSwitch.defaultProps = defaultProps;

export { TripleSwitch };
